import { IProfKind } from 'APIPackage/DictionariesModule/interfaces/IProfKind';

import { makeCreateDictionarySelectOption } from './makeCreateDictionarySelectOption';

export const createDictionaryProfKindSelectOption = makeCreateDictionarySelectOption<IProfKind>('guid', 'title');
